import * as React from 'react';
import * as style from './style.css';
import { FlatCard } from '../FlatCard';
import { jsx as _jsx } from "react/jsx-runtime";
export var FlatsList = function FlatsList(_ref) {
  var flats = _ref.flats,
    favoriteButton = _ref.favoriteButton,
    onFlatCardClick = _ref.onFlatCardClick;
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    id: "MvkFlatCards",
    "data-testid": "MvkFlatCards",
    children: flats.map(function (flat) {
      return /*#__PURE__*/_jsx(FlatCard, {
        favoriteButton: favoriteButton,
        flat: flat,
        onClick: onFlatCardClick
      }, flat.offerId);
    })
  });
};